export default "__VITE_ASSET__OuDZQerf__"